// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__SIZbq"};